import axiosInstance from "../../apiAxios/axiosInstance";

/**
 * ✅ GET: Role List
 */
export const getRoleList = async (payload) => {
  try {
    const response = await axiosInstance.post("/admin/roles-list",payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
export const allActiveRole = async (payload) => {
  const response = await axiosInstance.get("/admin/active-role-list", payload);
  return response.data;
};
export const DeleteRole = async (payload) => {
  const res = await axiosInstance.post("/admin/roles-delete",payload) 
   return res.data
};
export const RoleUpdate = async (payload) => {
  const res = await axiosInstance.post("/admin/roles-update",payload) 
   return res.data
};

export const createRole = async (data) => {
  try {
    const response = await axiosInstance.post(
      "/admin/roles-store",
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};


export const getRoleById = async (id) => {
  try {
    const response = await axiosInstance.post("/admin/roles-show", {
      id,
    });

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
export const ChanegRoleStatus = async (paylaod) => {
    const response = await axiosInstance.post("/admin/roles-status-update",paylaod )
};